(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  const bar = document.querySelector('[data-key]');
  if (bar) {
    const key = bar.dataset.key;

    if (sessionStorage.getItem(key) === 'dismissed') {
      bar.hidden = true;
    }

    const closeBtn = bar.querySelector('[data-dismiss]');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        bar.hidden = true;
        sessionStorage.setItem(key, 'dismissed');
      });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('_layout-section--near');
            observer.unobserve(entry.target);
          }
        }
      },
      { rootMargin: '200% 0px 200% 0px', threshold: 0 }
    );

    const observeAll = () => {
      const nodes = document.querySelectorAll('._layout-section--deferred:not(._layout-section--near)');
      for (const el of nodes) observer.observe(el);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAll, { once: true });
    } else {
      observeAll();
    }

    document.addEventListener('shopify:section:load', observeAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('_editorial-section--near');
            observer.unobserve(entry.target);
          }
        }
      },
      { rootMargin: '200% 0px 200% 0px', threshold: 0 }
    );

    const observeAll = () => {
      const nodes = document.querySelectorAll('._editorial-section--deferred:not(._editorial-section--near)');
      for (const el of nodes) observer.observe(el);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAll, { once: true });
    } else {
      observeAll();
    }

    document.addEventListener('shopify:section:load', observeAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
